import Swipeable from '../../../../interface/Swipeable.js';
// import LOADER, { LoaderElementModel } from '../../../COMPONENT/loader/LOADER.js';
import DIV from '../../../DOM/div/DIV.js';
import BUTTONGROUP from '../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { HTMLELEMENT } from '../../../EL/EL.js';
import FORM from '../../../DOM/form/FORM.js';
import HERO from '../../../COMPONENT/hero/HERO.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import CONTENT from '../../../DOM/content/CONTENT.js';
// Model Structure
export const paneAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const paneData = makeDataStruct([
    ['loader']
]);
export const paneModel = makeStruct([
    ['attributes', paneAttr],
    ['data', paneData]
]);
// Simplified Model
export function pane(className, name) {
    return {
        element: 'PANE',
        attributes: paneAttr(className, name),
        data: paneData()
    };
}
/** A panel with swipe detection */
export default class PANE extends CONTENT {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('pane flex-vertical');
        this.implement(new Swipeable(this, parseInt(getComputedStyle(this.el).width) * 0.85, true, true));
        // this.implement(new Translatable(this));
        this.timeout = null;
        this.swipeUp = () => console.log('swipeUp');
        this.swipeDown = () => console.log('swipeDown');
        this.swipeLeft = () => console.log('swipeLeft');
        this.swipeRight = () => console.log('swipeRight');
        this.on('scroll', () => this.onScroll());
        // this.on('translate', () => this.translate());
        // Listen for language change at PAGE level
        // this.getMain().on('translate', (event: Event) => {
        // 	const customEvent = event as CustomEvent<TranslateEvent>;
        // 	this.do(new Translate(this, customEvent.detail.language));
        // });
        // console.log('PANE created', this.getMain().getConfig());
    }
    addHero(model) {
        return this.addChild(new HERO(this, model));
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    addForm(model) {
        return this.addChild(new FORM(this, model));
    }
    addButtonGroup(model) {
        return this.addChild(new BUTTONGROUP(this, model));
    }
    onScroll() {
        let tabs = this.main.sidebarRight.tabGroup.get(null, 'TAB');
        //console.log('scrolling pane', tabs);
        //let t = 0;
        tabs.forEach((tab) => {
            //let header = tab.data.header;
            let threshold = 50;
            // let { top } = tab.data.target.el.getBoundingClientRect(); // bottom
            // //console.log('tab['+t+']', threshold, top, bottom, bottom - top);
            // if (top <= threshold) {
            // 	tab.addClass('scrolled');
            // } else {
            // 	tab.removeClass('scrolled');
            // }
            /*if (tab.data.header.el.getBoundingClientRect().top = 0) {
                console.log('Trigger: top of header: ' + header.el.innerText + ' reached', header);
                tab.addClass('scrolled-past');
            }
            if (tab.data.header.el.getBoundingClientRect().bottom <= 0) {
                console.log('Trigger: tab['+t+'] bottom of header: ' + header.el.innerText + ' reached', header);
                tab.addClass('scrolled-past');
            }*/
            //t++;
        });
    }
    getPage() {
        return this.getMain();
    }
}
